import { render, staticRenderFns } from "./UpdateAgreementModal.vue?vue&type=template&id=8c230b5a&"
import script from "./UpdateAgreementModal.vue?vue&type=script&lang=js&"
export * from "./UpdateAgreementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports